import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
Vue.use(Router);
import { auth } from './firebaseConfig.js';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/meeting-rooms'
    },
    {
      path: '/',
      redirect: '/meeting-rooms'
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/meeting-rooms',
      name: 'meeting-rooms',
      meta: {
        requiresAdmin: true,
        requiresCurrentLocation: true
      },
      component: () =>
        import(
          /* webpackChunkName: "meeting-rooms" */ './views/MeetingRooms.vue'
        )
    },
    {
      path: '/meeting-rooms/:roomid/bookings',
      name: 'bookings',
      meta: {
        requiresAdmin: true,
        requiresCurrentLocation: true,
        requiresRoom: true
      },
      component: () =>
        import(/* webpackChunkName: "bookings" */ './views/Bookings.vue')
    },
    {
      path: '/meeting-rooms/bookings-calendar',
      name: 'bookings-calendar',
      meta: {
        requiresAdmin: true,
        requiresCurrentLocation: true
      },
      component: () =>
        import(
          /* webpackChunkName: "bookings-calendar" */ './views/BookingsCalendar.vue'
        )
    },
    {
      path: '/message-board',
      name: 'message-board',
      meta: {
        requiresAdmin: true,
        requiresCurrentLocation: true
      },
      component: () =>
        import(
          /* webpackChunkName: "message-board" */ './views/MessageBoard.vue'
        )
    },
    {
      path: '/profiles',
      name: 'profiles',
      meta: {
        requiresAdmin: true,
        requiresCurrentLocation: true
      },
      component: () =>
        import(/* webpackChunkName: "profiles" */ './views/Profiles.vue')
    },
    {
      path: '/referral-codes',
      name: 'referral-codes',
      meta: {
        requiresAdmin: true
      },
      component: () =>
        import(
          /* webpackChunkName: "refferal-codes" */ './views/ReferralCodes.vue'
        )
    },
    {
      path: '/admins',
      name: 'admins',
      meta: {
        requiresAdmin: true,
        requiresOwner: true,
        requiresCurrentLocation: true
      },
      component: () =>
        import(/* webpackChunkName: "admins" */ './views/Admins.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const requiresOwner = to.matched.some(record => record.meta.requiresOwner);
  const requiresRoom = to.matched.some(record => record.meta.requiresRoom);
  if (requiresRoom && !store.state.currentLocation) {
    next('meeting-rooms');
  }
  if (requiresOwner) {
    auth.currentUser
      .getIdTokenResult()
      .then(idTokenResult => {
        if (idTokenResult.claims.owner) {
          next();
        } else {
          alert("Sorry, you don't have permission");
          next('meeting-rooms');
        }
      })
      .catch(err => {
        alert(err);
        store.dispatch('clearData');
        next('login');
      });
  } else if (requiresAdmin) {
    if (auth.currentUser) {
      auth.currentUser
        .getIdTokenResult()
        .then(idTokenResult => {
          if (idTokenResult.claims.owner || idTokenResult.claims.admin) {
            next();
          } else {
            alert("Sorry, you don't have permissions");
            store.dispatch('clearData');
            next('login');
          }
        })
        .catch(err => {
          alert(err);
          store.dispatch('clearData');
          next('login');
        });
    } else {
      store.dispatch('clearData');
      next('login');
    }
  } else {
    next();
  }
});

export default router;
